import type { Culte } from '@/types/Culte'

export const CULTES: Culte[] = [
  {
    jour: 'Mercredi',
    label: "Culte d'enseignement biblique",
    creneaux: [{ heureDebut: '17h30', heureFin: '19h30' }],
  },
  {
    jour: 'Jeudi',
    label: "Culte d'intercession",
    creneaux: [{ heureDebut: '17h30', heureFin: '19h30' }],
    note: 'Jeudi Etoko',
  },
  {
    jour: 'Samedi',
    label: 'Réunion de la jeunesse',
    creneaux: [{ heureDebut: '16h30', heureFin: '18h30' }],
  },
  {
    jour: 'Dimanche',
    label: 'Culte dominical',
    creneaux: [
      { heureDebut: '07h30', heureFin: '09h30' },
      { heureDebut: '10h30', heureFin: '12h30' },
    ],
  },
]
